export default "__VITE_ASSET__Nl3FZ72b__"